module.exports = __webpack_public_path__ + "static/media/visa-secure.1e5393f0.png";